export const validateUserData = (data) => {
    const errors = {};
  
    if (!data.first_name.trim()) {
      errors.first_name = 'First name is required';
    } else if (data.first_name.length > 30) {
      errors.first_name = 'First name cannot exceed 30 characters';
    }
    
    if (!data.last_name.trim()) {
      errors.last_name = 'Last name is required';
    } else if (data.last_name.length > 30) {
      errors.last_name = 'Last name cannot exceed 30 characters';
    }
  
    if (!data.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      errors.email = 'Valid email is required';
    }
  
    if (data.phone && !/^[0-9]{2,15}$/.test(data.phone)) {
      errors.phone = 'Phone number must contain only numbers and be between 2 and 15 digits';
    }
  
    return errors;
  };
